import { render, staticRenderFns } from "./ProductHeader.vue?vue&type=template&id=580cc207&scoped=true"
import script from "./ProductHeader.vue?vue&type=script&lang=js"
export * from "./ProductHeader.vue?vue&type=script&lang=js"
import style0 from "./ProductHeader.vue?vue&type=style&index=0&id=580cc207&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580cc207",
  null
  
)

export default component.exports